export const imageUrl = (url) => `url("${url}")`

export function createThemeAssets(loadImage) {
    return {
        common: {
            gift: loadImage('common/gift.png'),
            hot: loadImage('common/hot.gif'),
            empty: loadImage('common/empty.png'),
            frameCorners: {
                topLeft: loadImage('common/frame-corner-top-left.png'),
                topRight: loadImage('common/frame-corner-top-right.png'),
                bottomLeft: loadImage('common/frame-corner-bottom-left.png'),
                bottomRight: loadImage('common/frame-corner-bottom-right.png')
            }
        },
        home: {
            pageBg: loadImage('home/page-bg.png'),
            bannerBg: loadImage('home/banner-bg.png'),
            redeemCodeIcon: loadImage('home/redeem-code-icon.png'),
            noticeIcon: loadImage('home/notice-icon.webp'),
            gameSectionHeaderBg: loadImage('home/game-section-header-bg.png'),
            jackpotBg: loadImage('home/jackpot-bg.png'),
            frameCorners: {
                topLeft: loadImage('home/frame-corner-top-left.png'),
                topRight: loadImage('home/frame-corner-top-right.png'),
                bottomLeft: loadImage('home/frame-corner-bottom-left.png'),
                bottomRight: loadImage('home/frame-corner-bottom-right.png')
            },
            eventCardCorners: {
                topLeft: loadImage('home/event-card-corner-top-left.png'),
                topRight: loadImage('home/event-card-corner-top-right.png'),
                bottomLeft: loadImage('home/event-card-corner-bottom-left.png'),
                bottomRight: loadImage('home/event-card-corner-bottom-right.png')
            },
            category: {
                popular: loadImage('home/category-popular.webp'),
                slots: loadImage('home/category-slots.webp'),
                recent: loadImage('home/category-recent.webp'),
                favorite: loadImage('home/category-favorite.webp'),
                hot: loadImage('home/category-hot.png'),
                hotActive: loadImage('home/category-hot-active.png'),
                recentPlain: loadImage('home/category-recent.png'),
                recentActive: loadImage('home/category-recent-active.png'),
                search: loadImage('home/search.png'),
                searchActive: loadImage('home/search-active.png')
            }
        },
        header: {
            menuToggle: loadImage('header/menu-toggle.png'),
            mobileArrow: loadImage('header/mobile-arrow.png'),
            dropdownArrow: loadImage('header/dropdown-arrow.png')
        },
        notification: {
            bgTop1: loadImage('notification/bg-top1.png')
        },
        tabbar: {
            sport: loadImage('tabbar/sport.png'),
            menu: loadImage('tabbar/menu.png'),
            menuActive: loadImage('tabbar/menu-active.png'),
            home: loadImage('tabbar/home.png'),
            homeActive: loadImage('tabbar/home-active.png'),
            affiliate: loadImage('tabbar/affiliate.png'),
            affiliateActive: loadImage('tabbar/affiliate-active.png'),
            vip: loadImage('tabbar/vip.png'),
            vipActive: loadImage('tabbar/vip-active.png'),
            profile: loadImage('tabbar/profile.png'),
            profileActive: loadImage('tabbar/profile-active.png'),
            activeBorders: [
                loadImage('tabbar/active-corner-top-left.png'),
                loadImage('tabbar/active-corner-top-right.png'),
                loadImage('tabbar/active-corner-bottom-left.png'),
                loadImage('tabbar/active-corner-bottom-right.png')
            ]
        },
        footer: {
            borderTop: loadImage('footer/border-top.png'),
            borderBody: loadImage('footer/border-body.png')
        },
        share: {
            bgShareMoney: loadImage('share/bg-shareMoney.png'),
            bgSharePeople: loadImage('share/bg-sharePeople.png'),
            bgTop: loadImage('share/bg-top.png'),
            facebook: loadImage('share/facebook.png'),
            iconFacebook: loadImage('share/icon_fackbook.png'),
            iconHowShare: loadImage('share/icon_howShare.png'),
            iconInstagram: loadImage('share/icon_ins.png'),
            iconInviteDate: loadImage('share/icon_inviteDate.png'),
            iconTelegram: loadImage('share/icon_telegram.png'),
            iconTiktok: loadImage('share/icon_tiktok.png'),
            iconWhatsapp: loadImage('share/icon_whatsapp.png'),
            iconX: loadImage('share/icon_x.png'),
            iconYoutube: loadImage('share/icon_youtube.png'),
            inviteBanner1: loadImage('share/invite_banner1.png'),
            inviteBanner2: loadImage('share/invite_banner2.png'),
            inviteBanner3: loadImage('share/invite_banner3.png'),
            inviteBanner4: loadImage('share/invite_banner4.png'),
            proxy: loadImage('share/proxy.png'),
            shareBg: loadImage('share/share_bg.png'),
            treasureChest: loadImage('share/TreasureChest.png'),
            treasureLock: loadImage('share/TreasureLock.png'),
            treasureUnlock: loadImage('share/TreasureUnLock.png'),
            trumpet: loadImage('share/trumpet.png'),
            redemptionCodeTitle: loadImage('share/redemption-code-title.png')
        },
        person: {
            avatar: loadImage('person/avatar.png'),
            bgVip: loadImage('person/bg-vip.png'),
            bgVipBottom: loadImage('person/bg-vipBottom.png'),
            bgVipPc: loadImage('person/bg-vipPc.png'),
            arrow: loadImage('person/icon-arrow.png'),
            betsVip: loadImage('person/icon-betsVip.png'),
            deposit: loadImage('person/icon-Deposit.png'),
            depositVip: loadImage('person/icon-DepositVip.png'),
            exchange: loadImage('person/icon-exchange.png'),
            history: loadImage('person/icon-History.png'),
            install: loadImage('person/icon-Install.png'),
            notification: loadImage('person/icon-Notification.png'),
            password: loadImage('person/icon-Senha.png'),
            service: loadImage('person/icon-service.png'),
            transaction: loadImage('person/icon-Transaction.png'),
            withdraw: loadImage('person/icon-Withdraw.png'),
            copy: loadImage('person/icon_copy.png'),
            logout: loadImage('person/icon_logout.png'),
            notificationBell: loadImage('person/icon_notification.png'),
            wallet: loadImage('person/icon_Wallet.png'),
            vipCenterBg: loadImage('person/vip-center-bg.png'),
            membershipEmblem: loadImage('person/vip-membership-emblem.jpg')
        },
        event: {
            topShellBg: loadImage('event/top-shell-bg.png'),
            topBg: loadImage('event/top-bg.png'),
            topRight: loadImage('event/top-right.png')
        },
        signIn: {
            vipIcon: loadImage('signIn/vipicon.png'),
            vipIconActive: loadImage('signIn/vipiconact.png'),
            lock: loadImage('signIn/suo.png')
        },
        sidebar: {
            sidebarBorder: loadImage('sidebar/sidebar-border.png'),
            menuItemBorder: loadImage('sidebar/menu-item-border.png'),
            sharePanelBg: loadImage('sidebar/share-panel-bg.png'),
            inviteFree: loadImage('sidebar/invite-free.png'),
            copy: loadImage('sidebar/copy.png'),
            vipBadge: loadImage('sidebar/vip-badge.png'),
            vip: loadImage('sidebar/vip.png'),
            vipActive: loadImage('sidebar/vip-active.png'),
            promotion: loadImage('sidebar/promotion.png'),
            promotionActive: loadImage('sidebar/promotion-active.png'),
            affiliate: loadImage('sidebar/affiliate.png'),
            affiliateActive: loadImage('sidebar/affiliate-active.png'),
            redemptionCode: loadImage('sidebar/redemption-code.png'),
            redemptionCodeActive: loadImage('sidebar/redemption-code-active.png'),
            socialMedia: loadImage('sidebar/social-media.png'),
            socialMediaActive: loadImage('sidebar/social-media-active.png'),
            languageArrow: loadImage('sidebar/language-arrow.png'),
            customerService: loadImage('sidebar/customer-service.png'),
            refresh: loadImage('sidebar/refresh.png'),
            pathArrow: loadImage('sidebar/path-arrow.png'),
            telegram: loadImage('sidebar/telegram.gif'),
            hotBg: loadImage('sidebar/hot-bg.png')
        },
        login: {
            popupBg: loadImage('login/popup-bg.png'),
            exitConfirmBg: loadImage('login/exit-confirm-bg.png')
        }
    }
}
